import { FC } from 'react';
import { get, isNil } from 'lodash';
import moment from 'moment';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import victimIcon from 'images/victim-icon.svg';
import { COLORS } from 'constants/design';
import {
  getLiveDocumentViewUrl,
  openDocument,
} from 'containers/UploadDocuments/utils';
import Document from 'components/Document';
import { translate } from 'containers/services/translate';
import messages from 'containers/TransactionManagerTimeLine/VictimInfo/messages';
import TextElement from 'containers/CourtManagerAssignedExpertise/TextElement';
import { TransactionDocumentType } from 'typings/globalTypes';

export interface RecapDocumentsProps {
  intl: IntlShape;
  documents: TransactionDocumentType[];
  receptionDate: any;
  requestGetDocByDocumentumId: Function;
  revenu: string;
}

const RecapDocuments: FC<RecapDocumentsProps> = props => {
  return (
    <CustomAccordion
      title={translate({ ...messages.documentsTitle }, props)}
      textColor={COLORS.ACCORDION_TEXT_BLUE}
      bgColor={COLORS.ACCORDION_BG_BLUE}
      image={victimIcon}
    >
      <Grid container spacing={1} alignItems={'center'}>
        {!isNil(props.revenu) && (
          <Grid item xs={2} style={{ marginTop: -8 }}>
            <TextElement
              label={translate(messages.revenueFieldTitle, props)}
              value={props.revenu}
              withoutPadding={true}
            />
          </Grid>
        )}
        {!isNil(props.receptionDate) && (
          <Grid item xs={2} style={{ marginTop: -8 }}>
            <TextElement
              label={translate(messages.dateReception, props)}
              value={moment(props.receptionDate).format('YYYY-MM-DD')}
              withoutPadding={true}
            />
          </Grid>
        )}
        {props.documents.map((doc: TransactionDocumentType) => (
          <Grid item xs={5}>
            <Document
              name={doc?.name}
              type={doc?.type}
              icon={
                <VisibilityIcon
                  className="consult"
                  onClick={() => {
                    if (!isNil(get(doc, 'documentumId', null))) {
                      props.requestGetDocByDocumentumId(
                        getLiveDocumentViewUrl(
                          '',
                          '',
                          true,
                          (get(doc, 'documentumId', null) as unknown) as string,
                        ),
                      );
                    } else {
                      openDocument(doc?.url)();
                    }
                  }}
                />
              }
            />
          </Grid>
        ))}
      </Grid>
    </CustomAccordion>
  );
};

export default injectIntl(RecapDocuments);
